export const UPDATE_ORG_AGENCIES = 'action.agencies.update.org.agencies';

export const updateOrgAgencies = agencies => {
    return {
        type: UPDATE_ORG_AGENCIES,
        agencies,
    };
};
